import ApiClient from '../ApiClient';

class LocationExtractorAPI extends ApiClient {
  constructor() {
    super('whatsapp/location_extractor', { accountScoped: true });
  }

  extract(url) {
    return axios.post(this.url, { url });
  }

  search(query) {
    return axios.post(this.url, { query, search: true });
  }
}

export default new LocationExtractorAPI();
